import React, { useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { DillModal } from '../../../general/Dill/DillModal';
import { DillButton } from '../../../general/Dill/DillButton';
import { Printer } from 'phosphor-react';

interface Props {
  open: boolean;
  onClose: () => void;
  url: string;
  title?: string;
}

const QRCodePrintModal: React.FC<Props> = ({ open, onClose, url, title }) => {
  const qrRef = useRef<HTMLDivElement>(null);

  const handlePrint = () => {
    const svgEl = qrRef.current?.querySelector('svg');
    if (!svgEl) return;

    const svgData = new XMLSerializer().serializeToString(svgEl);
    const printWindow = window.open('', '_blank', 'width=400,height=500');
    if (!printWindow) return;

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>${title ?? 'QR Code'}</title>
          <style>
            body { margin: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; font-family: sans-serif; }
            h2 { font-size: 16px; margin-bottom: 16px; color: #111; }
            svg { width: 240px; height: 240px; }
            @media print { body { height: auto; padding: 40px; } }
          </style>
        </head>
        <body>
          ${title ? `<h2>${title}</h2>` : ''}
          ${svgData}
          <script>window.onload = () => { window.print(); window.close(); }<\/script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <DillModal
      open={open}
      onClose={onClose}
      title={title ?? 'QR Code'}
      maxWidth="340px"
      overlayZIndex={60}
      footer={
        <div className="flex gap-2 justify-end">
          <DillButton onClick={onClose} variant="secondary" label="Close" />
          <DillButton
            onClick={handlePrint}
            variant="primary"
            label="Print"
            icon={<Printer size={14} weight="bold" />}
          />
        </div>
      }>
      <div className="flex flex-col items-center gap-4 py-4">
        <div ref={qrRef} className="p-4 bg-white border border-gray-200 rounded-xl shadow-sm">
          <QRCodeSVG value={url} size={200} level="M" />
        </div>
        <p className="text-xs text-gray-400 text-center break-all max-w-[260px]">{url}</p>
      </div>
    </DillModal>
  );
};

export default QRCodePrintModal;
